import BaseModelAPI from '../BaseModelAPI';

export default class ProblemCategoryList extends BaseModelAPI {

	static entity = 'problemcategorylist'
	static entityName = 'problemcategory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
